export default (theme) => ({
    root: {},
    tabsRoot: {
        padding: '0 20px',
    },
    shrinkedTab: {
        whiteSpace: 'nowrap',
        flex: 1,
        minWidth: 210,
        padding: '6px 0 10px 16px',
        ...theme.typography.defaultText,
    },
    activeShrinkedTab: {
        '& $shrinkedTabText': {
            '&::after': {
                zIndex: 1,
                boxSizing: 'border-box',
                backgroundColor: theme.colors.actionMinor[500],
                height: 0.5,
                top: '32px',
                left: 0,
                right: 0,
                content: '""',
                position: 'absolute',
            },
        },
    },
    shrinkedTabSelect: {
        overflow: 'hidden',
        zIndex: 100,
        '& .hoi-poi-select__menu': {
            position: 'relative',
            boxShadow: 'none !important',
            marginBottom: 0,
        },
    },
    shrinkedTabText: {
        position: 'relative',
        transition: 'color 0.3s cubic-bezier(0.35, 0, 0.25, 1)',
        lineHeight: '20px',
        cursor: 'pointer',
        ...theme.typography.defaultText,
        color: theme.colors.utility.textSecondary,
        '&:hover': {
            '& $shrinkedTabText': {
                color: theme.colors.utility.textPrimary,
            },
        },
    },
});
